// extracted by mini-css-extract-plugin
module.exports = {"table-map-stage":"_1FSiYSt7znSd_QsQNAUwOI","wrapper":"_2QbuX_R_uD5nNafHEmBPIg"};